module.exports = __webpack_public_path__ + "static/media/onco.0100ece2.jpg";